import React, { Component } from 'react';
import { Grid, Row, Col, FormControl, Glyphicon } from 'react-bootstrap';

import Constants from '../../../Phi/Constants';

import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';

import './Vaccination.css';



// Constants

const YEARS = [
    '0',
    '01',
    '02',
    '03',
    '04'
];

const MONTHS = [
    '0',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
];



class Vaccination extends Component {

    constructor(props) {
        super(props);

        this.state = {
            vaccineList: []
        };
    }


    // Lifecycle Methods

    render() {
        return (
        <div className="hsg-vac-root">

            {(this.props.vaccines.isLoading) ?
                <div style={{paddingTop: 100}}><Loader /></div>
            
            :
            
                <Grid>
                
                    {/* Column Header row */}
                    <Row className="show-grid" style={{marginBottom: 10}}>
                    
                        <Col xs={3}><span className="hsg-vac-column-header">IMMUNIZATION</span></Col>

                        <Col xs={2}><span className="hsg-vac-column-header">AGE RECOMMENDED</span></Col>

                        <Col xs={3}><span className="hsg-vac-column-header">CATCH UP PERIOD</span></Col>

                        <Col xs={4}><span className="hsg-vac-column-header">AGE VACCINATION GIVEN (OPTIONAL)</span></Col>

                    </Row>


                    {/* General Vaccination rows */}
                    {this.renderRow(this.state.vaccineList, 'General  Vaccination')}
                    

                    <Row className="show-grid">
                    <Col xs={12} style={{padding: 0}}>
                        <h3 className="hsg-vac-header-text">BOOSTER DOSES</h3>
                    </Col>
                    </Row>


                    {/* Booster Dose rows */}
                    {this.renderRow(this.state.vaccineList, 'Booster Dose')}


                    <Row className="show-grid">
                    <Col xs={12} style={{padding: 0}}>
                        <h3 className="hsg-vac-header-text">ADDITIONAL VACCINATIONS</h3>
                    </Col>
                    </Row>


                    {/* Additional Vaccination rows */}
                    {this.renderRow(this.state.vaccineList, 'Additional Vaccination')}

                </Grid>}
        
        </div>);
    }


    componentDidMount() {
        if(this.props.vaccines.loaded) {
            this.setState({vaccineList: this.parseList(this.props.vaccines.data, this.props.child.vaccination)});
        }

        else {
            this.props.fetchVaccination();
        }
    }


    componentWillReceiveProps(newProps) {
        if(!newProps.vaccines.isLoading && this.props.vaccines.isLoading && newProps.vaccines.loaded) {
            this.setState({vaccineList: this.parseList(newProps.vaccines.data, newProps.child.vaccination)});
        }
        
        if (newProps.child.userId !== this.props.child.userId) {
            this.setState({ vaccineList: this.parseList(newProps.vaccines.data, newProps.child.vaccination) });
        }
    }



    // Rendering Methods

    renderRow(list, type) {
        const viewList = [];

        let count = 1;

        list.forEach((item, pos) => {
            if(item.type !== type) return;

            let color = '#FFFFFF';
            if((pos + 1) % 2 == 0) color = '#F9F9F9';

            let end = 1;
            if(item.dose.length > 1 && item.showAll) end = item.dose.length;

            for(let i=0 ; i < end ; i++) {
                viewList.push(
                    <Row className="show-grid hsg-vac-row-container" key={count}
                        style={{background: item.dose[i].status ? '#E8F9F5' : color}}>
                        <Col xs={3}>
                            <div className="hsg-vac-checkbox">
                                <input type="checkbox"
                                    id={'hsg-vac-checkbox-' + count + '-' + pos}
                                    checked={item.dose[i].status}
                                    onChange={(e) => this.onChangeVaccineStatus(e, pos, i)} />
                                <label htmlFor={'hsg-vac-checkbox-' + count + '-' + pos} />
                            </div>

                            <span className="hsg-vac-name-text">{i === 0 ? item.name : ''}</span>

                            {item.dose.length > 1 && i === 0 &&
                                <span className="hsg-vac-expand-btn"
                                    onClick={() => this.onExpandVaccine(pos)}>
                                    <Glyphicon glyph={item.showAll ? 'menu-up' : 'menu-down'} />
                                </span>}
                        </Col>

                        <Col xs={2}>{item.dose[i].ageRecommended}</Col>

                        <Col xs={3}>{item.dose[i].catchUpPeriod}</Col>

                        <Col xs={4}>
                            <select
                                className="hsg-vac-dropdown"
                                value={item.dose[i].yearGiven}
                                onChange={(e) => this.onChangeYear(e.target.value, pos, i)}>
                                {YEARS.map((year, i) => <option key={i} value={year}>{year}</option>)}
                            </select>

                            {' '}<span style={{marginRight: 20}}>Year(s)</span>

                            <select
                                className="hsg-vac-dropdown"
                                value={item.dose[i].monthGiven}
                                onChange={(e) => this.onChangeMonth(e.target.value, pos, i)}>
                                {MONTHS.map((month, i) => <option key={i} value={month}>{month}</option>)}
                            </select>

                            {' '}<span>Month(s)</span>
                        </Col>
                    </Row>
                );

                count++;
            }
        });

        return viewList;
    }



    // Event Listeners

    onChangeVaccineStatus(e, pos, pos1) {
        const list = this.state.vaccineList;

        list[pos].dose[pos1].status = e.target.checked;

        this.setState({vaccineList: list});

        this.props.saveVaccination(this.generatePayload());
    }


    onExpandVaccine(pos) {
        const list = this.state.vaccineList;

        list[pos].showAll = !list[pos].showAll;

        this.setState({vaccineList: list});
    }


    onChangeYear(year, pos, pos1) {
        const list = this.state.vaccineList;

        const dose = list[pos].dose[pos1];

        dose.yearGiven = year;

        this.setState({vaccineList: list});
    }


    onChangeMonth(month, pos, pos1) {
        const list = this.state.vaccineList;

        const dose = list[pos].dose[pos1];

        dose.monthGiven = month;

        this.setState({vaccineList: list});
    }



    // Other methods

    parseList(list, vaccination) {
        const result = [];

        let selected = null;

        if (vaccination && vaccination.length > 0) {
            selected = vaccination;
        }

        list.forEach((item, pos) => {
            const vac = {
                id: item.id,
                name: item.name,
                type: item.type,
                dose: JSON.parse(item.custom_json)
            };

            let saved = null;
            if(selected !== null) {
                const obj = selected.find((data) => data.id === vac.id);
                if(Boolean(obj)) saved = obj.dose;
            }

            vac.dose.forEach((dose, pos1) => {
                dose.yearGiven = YEARS[0];
                dose.monthGiven = MONTHS[0];

                if(saved !== null) {
                    let status = false;
                    for(let i=0 ; i < saved.length ; i++) {
                        if(saved[i].index === pos1) {
                            status = true;
                            dose.yearGiven = saved[i].yearGiven;
                            dose.monthGiven = saved[i].monthGiven;

                            break;
                        }
                    }

                    dose.status = status;
                }
                else {
                    dose.status = false;
                }
            });

            if(vac.dose.length > 1) {
                vac.showAll = false;
            }

            result.push(vac);
        });

        return result;
    }


    generatePayload() {
        const payload = {
            hsgId: this.props.child.uuId,
            currentUserId: this.props.user.userId,
            description: 'Updating student Vaccination from Parent Dashboard'
        };

        const list = [];

        this.state.vaccineList.forEach((item, pos) => {
            const dose = [];
            item.dose.forEach((item1, pos1) => {
                if(item1.status) {
                    dose.push({
                        index: pos1,
                        yearGiven: item1.yearGiven,
                        monthGiven: item1.monthGiven
                    });
                }
            });

            if(dose.length > 0) {
                list.push({
                    id: item.id,
                    dose
                });
            }
        });

        const custom = {
            vaccination: list
        };

        payload.newCustom = JSON.stringify(custom);

        return payload;
    }

}



export default Vaccination